import React, { Component } from "react";
import { Button, Modal, Spin } from "antd";
import { connect } from "dva";

import GroupModal from "../../../components/NormGroup/NormGroup";
import EditGroupModal from "../../../components/NormGroup/EditGroup";
import AddNormModal from "../AddNormModal";
// import DeleteNormModal from '../DeleteNormModal'

const { confirm } = Modal;

@connect(({ norm, tree }) => ({
  selectedRowKeys: norm.selectedRowKeys,
  indexItem: tree.normDetail,
  spinProps: tree.spinProps
}))
class NormGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowEditGroup: false,
      // isShowNormGroup:true
      isShowAddModal: false,
      addNormformData: {
        type: 1,
        name: ""
      },
      changedName: "", // 表单更新后的名字
      changedNumber: "", // 表单更新后的编号
      form: {} // 分组的form
    };
  }

  componentDidMount = () => {
    this.handleFetchList();
  };

  handleChangeShow = () => {
    this.setState({
      isShowEditGroup: true
    });
  };

  handleShowAddModal = () => {
    this.setState({
      isShowAddModal: true
    });
  };

  // 新增指标
  handleAddNormOk = newData => {
    const { dispatch, record } = this.props;
    const { code, templateId, respondentOrgId } = record;
    const { name, number, type } = newData;
    const parentCode = code ? code : "";
    dispatch({
      type: "tree/addNormOrGroup",
      payload: {
        parentCode,
        numberName: number,
        nodeName: name,
        nodeType: type,
        templateId,
        respondentOrgId: respondentOrgId || ""
      },
      callback: this.handleFetchNormTree
    });
    this.setState({
      isShowAddModal: false
    });
  };

  handleEdit = () => {
    const { dispatch, record, indexItem } = this.props;
    const { changedName, changedNumber, form } = this.state;
    const { code, respondentOrgId, templateId } = record;
    const { name, number } = indexItem;
    const { validateFields } = form;
    if (typeof validateFields === "function") {
      validateFields(err => {
        if (!err) {
          dispatch({
            type: "tree/changeNormGroup",
            payload: {
              indexCode: code,
              numberName: changedNumber,
              nodeName: changedName,
              templateId,
              respondentOrgId: respondentOrgId || ""
            },
            callback: [this.handleFetchNormTree, this.handleFetchList]
          });
          this.setState({
            isShowEditGroup: false
          });
        }
      });
    } else {
      dispatch({
        type: "tree/changeNormGroup",
        payload: {
          indexCode: code,
          numberName: number,
          nodeName: name,
          templateId,
          respondentOrgId: respondentOrgId || ""
        },
        callback: [this.handleFetchNormTree, this.handleFetchList]
      });
      this.setState({
        isShowEditGroup: false
      });
    }
  };

  // 对指标分组内容进行修改时的回调
  onEdit = (number, name, form) => {
    this.setState({
      changedName: name,
      changedNumber: number,
      form
    });
  };

  // 获取指标树
  handleFetchNormTree = () => {
    const { dispatch, record } = this.props;
    const { templateId, respondentOrgId } = record;
    dispatch({
      type: "tree/getNormTree",
      payload: {
        templateId,
        respondentOrgId: respondentOrgId || ""
      }
    });
  };

  // 调获取分组列表接口
  handleFetchList = () => {
    const { record, dispatch } = this.props;
    const { templateId, code,respondentOrgId } = record;
    dispatch({
      type: "tree/getNormDetail",
      payload: {
        templateId,
        indexCode: code,
        respondentOrgId: respondentOrgId || ""
      }
    });
  };

  handleDeleteNorm = () => {
    const { record, dispatch, renderRoot } = this.props;
    const { templateId, code, respondentOrgId } = record;
    dispatch({
      type: "tree/deleteNorm",
      payload: {
        indexCodes: [code],
        templateId,
        respondentOrgId: respondentOrgId || ""
      },
      callback: [this.handleFetchNormTree, renderRoot]
    });
  };

  renderDeleteModal = () => {
    // const { selectedRowKeys, dispatch } = this.props;
    const deleteProps = {
      title: `删除指标`,
      content: "确定删除选中的指标吗？",
      okText: "确定",
      cancelText: "取消",
      centered: true,
      onOk: this.handleDeleteNorm
    };
    confirm({ ...deleteProps });
    return false;
    // confirm({
    //   title: `批量删除指标`,
    //   content: '确定删除选中的指标吗？',
    //   okText: '确定',
    //   cancelText: '取消',
    //   onOk: this.handleOk
    // });
    // 删除接口
    // console.log("TCL: deleteNorm -> selectedRowKeys", selectedRowKeys)
    // return false;
  };

  renderAddModal = () => {
    const { isShowAddModal, addNormformData } = this.state;
    const addNormProps = {
      title: "新增下级指标",
      visible: true,
      onCancel: () => this.setState({ isShowAddModal: false }),
      onOk: newData => this.handleAddNormOk(newData),
      data: addNormformData
    };
    return isShowAddModal && <AddNormModal {...addNormProps} />;
  };

  render() {
    const { isShowEditGroup } = this.state;
    const { indexItem, spinProps } = this.props;
    const { number, name } = indexItem;
    return (
      <div>
        <Spin {...spinProps}>
          <div className="setting-header">
            <Button onClick={this.handleShowAddModal} type="primary">
              + 新增下级指标
            </Button>
            {!isShowEditGroup && (
              <Button onClick={this.handleChangeShow}>
                编辑
              </Button>
            )}
          </div>
          {isShowEditGroup && (
            <EditGroupModal number={number} name={name} onEdit={this.onEdit} />
          )}
          {isShowEditGroup && (
            <Button type="primary" onClick={this.handleEdit}>
              保存修改
            </Button>
          )}
          {isShowEditGroup && (
            <Button onClick={this.renderDeleteModal} style={{ marginLeft: 15 }}>
              删除指标
            </Button>
          )}
          {!isShowEditGroup && <GroupModal number={number} name={name} />}
          {this.renderAddModal()}
        </Spin>
      </div>
    );
  }
}

export default NormGroup;
